/**
 * React component that renders a special button that updates its text to a loading indicator
 *  when in a "loading" state
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import BeatLoader from 'react-spinners/BeatLoader'
import { Button } from 'reactstrap'

const LoadButton = ({
  children,
  className,
  isLoading,
  disabled,
  loadColor,
  loadSize,
  onClick,
  ...props
}) => {
  const buttonProps = {
    className: cx(className),
    ...props
  }

  return isLoading ? (
    <Button {...buttonProps} disabled>
      <BeatLoader color={loadColor} size={loadSize} margin={'1px'} />
    </Button>
  ) : (
    <Button {...buttonProps} onClick={onClick} disabled={disabled}>{children}</Button>
  )
}

LoadButton.defaultProps = {
  children: 'Submit',
  className: '',
  title: '',
  isLoading: false,
  disabled: false,
  type: 'button',
  color: 'primary',
  loadColor: '#FFFFFF',
  loadSize: 10,
  onClick: (evt) => evt
}

LoadButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  color: PropTypes.string,
  loadColor: PropTypes.string,
  loadSize: PropTypes.number,
  onClick: PropTypes.func
}

export default LoadButton
